import React from "react";
import {
  MosaicLayout,
  MosaicLayoutProps
} from "@silversea-ssc/ui-components-react";
import DestinationCard from "../Card/DestinationCard";
import { CollectionMosaicDestinationFragment } from "types/graphql-types";
import {
  FilterByType,
  filterByDestinationType
} from "components/CollectionSlider/utils";
import {
  CruisePerDestinationCounts2Result,
  useCruisePerDestinationCounts
} from "components/FindYourCruise/useCruisePerDestinationCount";

interface DestinationsMosaicProps extends MosaicLayoutProps {
  filterByType: FilterByType;
  data: CollectionMosaicDestinationFragment[];
}

const DestinationsMosaic: React.FC<DestinationsMosaicProps> = ({
  filterByType,
  data,
  ...props
}) => {
  const showExpeditionsOnly = filterByType === "expeditions";
  const destinations = filterByDestinationType(data, filterByType);
  const countByDestination = useCruisePerDestinationCounts(true);

  return (
    <MosaicLayout {...props} data-content-name="destinations_mosaic">
      {destinations
        .filter(
          hasDestinationWebCodeAndCruises(
            countByDestination,
            showExpeditionsOnly
          )
        )
        .map((item) => {
          const { classic = 0, expedition = 0 } =
            countByDestination[item.destinationWebCode] || {};
          const total = showExpeditionsOnly ? expedition : classic + expedition;

          return (
            <DestinationCard
              key={item._id}
              title={item.card?.title?.localized || ""}
              description={item.card?.description?.localized}
              cruiseCount={total}
              image={item.card?.image}
              destinationWebCode={item.destinationWebCode}
              url={item.fullPath}
              trackingName={item.card?.trackingName?.en}
            />
          );
        })}
    </MosaicLayout>
  );
};

export default DestinationsMosaic;

const hasDestinationWebCodeAndCruises =
  (
    countByDestination: CruisePerDestinationCounts2Result,
    showExpeditionsOnly: boolean
  ) =>
  (
    x: CollectionMosaicDestinationFragment
  ): x is Omit<CollectionMosaicDestinationFragment, "destinationWebCode"> &
    Required<
      Pick<CollectionMosaicDestinationFragment, "destinationWebCode">
    > => {
    return (
      !!x.destinationWebCode &&
      (!showExpeditionsOnly ||
        (countByDestination[x.destinationWebCode]?.classic || 0) > 0 ||
        (countByDestination[x.destinationWebCode]?.expedition || 0) > 0)
    );
  };
